import { BrainClient } from "../base/api/BrainClient";
import { MeStore } from "../base/store/MeStore";
import { CotFlow } from "../cases/cot/CotFlow";
import { CotService } from "../cases/cot/CotService";
import { TitleService } from "../cases/preview/TitleService";
export class RegisterCot {
    static configure(container) {
        const it = (serviceIdentifier) => {
            return container.get(serviceIdentifier);
        };
        container
            .bind(CotFlow)
            .toConstantValue(new CotFlow(new CotService(it(BrainClient), it(MeStore)), new TitleService(it(BrainClient))));
    }
}
